import { useCallback, useEffect, useState } from "react";
import { fetchAccount, type AccountInfo } from "../../../api/account";
import { errorMessage } from "../../../errors";

/** The signed-in person's account: `null` while loading, with the load error and a way to fetch it again. */
export function useAccount(): { account: AccountInfo | null; loadError: string | null; reload: () => void } {
  const [account, setAccount] = useState<AccountInfo | null>(null);
  const [loadError, setLoadError] = useState<string | null>(null);

  const reload = useCallback(() => {
    setLoadError(null);
    fetchAccount()
      .then(setAccount)
      .catch((err: unknown) => setLoadError(errorMessage(err, "We couldn't load your account.")));
  }, []);

  useEffect(reload, [reload]);

  return { account, loadError, reload };
}
